<script lang="ts">
  import { BUTTON_VARIANT, BUTTON_SIZE } from '$lib/constants/constants';

  import UspModel from './UspModel.svelte';
  import Button from '../control/Button.svelte';

  export let heading: string;
  export let eyebrowText: string;
  export let primaryCta: Button;
  export let secondaryCtaText: string;
  export let secondaryCtaLink: string;
  export let usPsCollection: Array<UspModel>;
</script>

<div class="flex flex-col justify-center items-center text-center">
  <p class="font-semibold text-primary-700 text-sm sm:text-md">{eyebrowText}</p>
  <h2
    class="max-w-[21.875rem] sm:max-w-[100%] font-semibold text-gray-900 my-2 sm:my-3 text-30 sm:text-display-md"
  >
    {heading}
  </h2>

  <div class="flex flex-row flex-wrap gap-3 pb-16 pt-2 sm:pt-0">
    {#each usPsCollection?.items as uspModel}
      <UspModel
        icon={uspModel.icon}
        heading={uspModel.heading}
        description={uspModel.description}
      />
    {/each}
  </div>

  <div class="flex flex-col gap-6">
    <Button
      text={primaryCta?.text}
      url={primaryCta?.url}
      variant={BUTTON_VARIANT.PRIMARY}
      buttonSize={BUTTON_SIZE.LARGE}
      customClass="py-3 gap-0 plausible-event-name=uspPanel_CTA_{primaryCta?.text
        ?.split(' ')
        .join('_')}"
    ></Button>

    {#if secondaryCtaText && secondaryCtaLink}
      <a class="font-semibold text-gray-600 text-md" href={secondaryCtaLink}>{secondaryCtaText}</a>
    {/if}
  </div>
</div>
